export default __webpack_public_path__ + "static/screen_ipad_quiz-81238d5e0417778eb2e29dd5ca5de7f9.png";